import React, { useState } from 'react'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'
const JcTmpErrorContext = React.createContext()

// default value also need to set in reducer
const JcTmpErrorContextProvider = ({ children }) => {
  const [tmpError, setJcErrors] = useState([])
  const [okFunc, setOkFunc] = useState(_ => _) // if pass func in state , its call insterd of store
  const setTmpError = (data, closeFunc, extFunc = _ => _) => {
    setJcErrors(data)
    closeFunc && closeFunc()
    setOkFunc(_ => extFunc)
  }

  return (
    <JcTmpErrorContext.Provider value={{ tmpError, setTmpError }}>
      <JcTmpErrorDialog
        visible={tmpError.length > 0}
        errors={tmpError}
        closeErrorPrompt={_ => {
          setTmpError([])
          okFunc && typeof okFunc === 'function' && okFunc()
          setOkFunc(_ => _ => _)
        }}
      />
      {children}
    </JcTmpErrorContext.Provider>
  )
}

export { JcTmpErrorContextProvider }
export default JcTmpErrorContext
